import { updateField } from "vuex-map-fields";
import { resetState } from "~/util/reset_store_state/reset_store_state";
import useState from "./state";

const SET_POLICY = (state, policy) => {
  state.policy = policy;
};

const SET_POLICY_ID = (state, id) => {
  state.policyId = id;
};
const SET_RENDERABLE_TABS = (state, renderableTabs) => {
  state.renderableTabs = renderableTabs;
};

const SET_ATTACHABLES_WIDGET = (state, attachables) => {
  state.attachables = attachables;
};

const SET_PAGE_LOADED = (state, bool) => {
  state.pageLoaded = bool;
};
const SET_CUSTOMER = (state, customer) => {
  state.customer = customer;
};

const SET_ACTIVE_STEP_ID = (state, stepId) => {
  state.activeStepId = stepId;
};
const SET_ACTIVE_SECTION_ID = (state, id) => {
  state.activeSectionId = id;
};
const SET_CUSTOMER_ID = (state, id) => {
  state.customerId = id;
};
export default {
  SET_CUSTOMER_ID,
  SET_ACTIVE_SECTION_ID,
  SET_ACTIVE_STEP_ID,
  SET_CUSTOMER,
  SET_ATTACHABLES_WIDGET,
  SET_POLICY,
  SET_PAGE_LOADED,
  SET_POLICY_ID,
  SET_RENDERABLE_TABS,
  resetState: resetState(useState),
  updateField,
};
